import { postData } from '../utils/ajax-utils';

export default function initDieteticiansBlock() : void {
    const $dieteticiansEventContainer = document.querySelectorAll<HTMLElement>('.js-dieticians-events');
    
    $dieteticiansEventContainer.forEach($container => {
        new DieteticiansBlock($container);
    });
}

type ajaxGetFlfEventResponseType = {
    success: boolean,
    data: {
        html: string,
        page: number,
        total_events: number,
        total_pages_events: number,
    },
};

class DieteticiansBlock {
    $container: HTMLElement;
    getResultsAbortController: AbortController | null = null;
    $resultsContainer: HTMLElement;
    $currentPageInput: HTMLInputElement;
    $regionsSelect: HTMLSelectElement;
    $nextPageButton: HTMLButtonElement|null;
    $selectShowedValue: HTMLElement;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$resultsContainer = this.$container.querySelector('.js-dieticians-events-results') as HTMLElement;
        this.$currentPageInput = this.$container.querySelector('input[name="page"]') as HTMLInputElement;
        this.$regionsSelect = this.$container.querySelector('.dieticians-list-select-select') as HTMLSelectElement;
        this.$nextPageButton = this.$container.querySelector<HTMLButtonElement>('.js-dieticians-next-page');
        this.$selectShowedValue = this.$container.querySelector('.dieticians-list-select-category--current') as HTMLElement;

        // Lorsqu'on change de région
        this.$regionsSelect.addEventListener('change', () => {
            this.getEvents(1, (response: ajaxGetFlfEventResponseType) => {
                if (response.success) {
                    this.$resultsContainer.innerHTML = response.data.html;
                    this.$currentPageInput.value = '1';

                    if (this.$nextPageButton) {
                        if (response.data.total_pages_events > 1) {
                            this.$nextPageButton.style.display = '';
                        } else {
                            this.$nextPageButton.style.display = 'none';
                        }
                    }
                }
            });
        });

        // Lorsqu'on clique sur le bouton pour charger plus d'événements
        this.$nextPageButton?.addEventListener('click', () => {
            const page = (parseInt(this.$currentPageInput.value) + 1);

            this.getEvents(page, (response: ajaxGetFlfEventResponseType) => {
                if (response.success) {
                    this.$resultsContainer.innerHTML = this.$resultsContainer.innerHTML + response.data.html;
                    this.$currentPageInput.value = response.data.page.toString();

                    if (this.$nextPageButton && response.data.total_pages_events === page) {
                        this.$nextPageButton.style.display = 'none';
                    }
                }
            });
        });
    }

    /**
     * 
     * @param {number} page 
     * @param {CallableFunction} callback 
     * 
     * @return {void}
     */
    getEvents(page: number, callback: CallableFunction) : void
    {
        if (this.getResultsAbortController) {
            this.getResultsAbortController.abort();
        }

        this.getResultsAbortController = new AbortController();

        this.$container.classList.add('loading');

        postData(script_var.ajax_url, {
            action: 'ajax_get_flf_events',
            venues: this.$regionsSelect.value,
            page: page.toString(),
        }, this.getResultsAbortController.signal).then(response => {
            callback(response);
        }).finally(() => {
            this.getResultsAbortController = null;
            const text = this.$regionsSelect.options[this.$regionsSelect.selectedIndex].text;
            this.$selectShowedValue.innerText = text;

            this.$container.classList.remove('loading');
        }).catch(() => {
            return;
        });
    }
}
